import React from 'react'
import { ToastContentProps } from 'react-toastify'
import { getToastTranslation } from '../../app/helpers/translationHelper'

interface IParams {
    username: string;
    toastContentProps: ToastContentProps;
}

const UserIsSharingToast: React.FC<IParams> = ({ username, toastContentProps }) => {
    return (
        <div>
            <i className="fas fa-user" aria-hidden="true"></i>
            <span className="font-weight-bold text-uppercase"> {username}</span>
            <span> {getToastTranslation("user_is_sharing")}</span>
        </div>
    )
}

export default UserIsSharingToast
